import { UserTagProps } from './UserTag.decl';

import { CrownFilled } from '@aircall/icons';
import { Box, BoxProps, Icon, Tag, ThemeProvider, Typography } from '@aircall/tractor-v2';
import { useTranslation } from 'react-i18next';

function getTranslatedLabel(isAdmin: boolean, isActive: boolean) {
  if (!isActive) {
    return 'app.pending_validation';
  }
  return isAdmin ? 'app.roles.admin' : 'app.roles.user';
}

export function UserTag({ isAdmin, isActive }: UserTagProps) {
  const { t } = useTranslation();
  const translatedLabel = getTranslatedLabel(isAdmin, isActive);

  return (
    <ThemeProvider>
      <Tag variant='white' mode='outline' data-test='user-tag'>
        {isActive && isAdmin && (
          <Icon
            component={CrownFilled}
            color='warning-600'
            size='s'
            data-test='user-tag-admin-icon'
          />
        )}
        <Typography variant='bodyMediumS'>{t(translatedLabel)}</Typography>
      </Tag>
    </ThemeProvider>
  );
}

export function PendingValidationTag({ ...boxProps }: BoxProps) {
  const { t } = useTranslation();

  return (
    <ThemeProvider>
      <Box {...boxProps}>
        <Tag variant='white' mode='outline' size='small' data-test='pending-validation-tag'>
          {t('app.pending_validation')}
        </Tag>
      </Box>
    </ThemeProvider>
  );
}
